var _window;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// import '@babel/polyfill';
import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import { globalApi, coreApi, domains } from "./api";
import { orgDomain, orgId } from "./configs/const";
import state from "./store";
import { saveLocale } from "./service";
import { getEnv, isMobileClient } from "./utils/env";
var fetchNum = 2; // 失败后请求的次数
var yxt_i18n_json, request_axios_instance, lastLang, isLoadBaidu;
Vue.use(VueI18n);

// 获取search文件
export var getLangFiles = function getLangFiles(params) {
  return globalApi.post("langfiles/search", params);
};

// 获取cdn的url，t和r环境一致，d环境为测试环境
var getCDNUrl = function getCDNUrl(type) {
  if (type === "ali") {
    return window.feConfig.common.imagesBaseUrl + "orgsv2";
  } else {
    return window.feConfig.common.picobd + "orgsv2";
  }
};
// 获取cdn文件列表
var getLangFileList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(lastLang !== getLanguage())) {
              _context.next = 7;
              break;
            }
            lastLang = getLanguage();
            request_axios_instance = axios.get(getCDNUrl(type) + "/glbl/lang/ver/" + getEnv() + "/custom/" + getLanguage() + "_index.json");
            _context.next = 5;
            return request_axios_instance;
          case 5:
            yxt_i18n_json = _context.sent;
            return _context.abrupt("return", yxt_i18n_json);
          case 7:
            // 语种一致（防止request_axios_instance这个实例不存在）
            if (!request_axios_instance) {
              request_axios_instance = axios.get(getCDNUrl(type) + "/glbl/lang/ver/" + getEnv() + "/custom/" + getLanguage() + "_index.json");
            }
            // 没有i18n对象
            if (yxt_i18n_json) {
              _context.next = 12;
              break;
            }
            _context.next = 11;
            return request_axios_instance;
          case 11:
            yxt_i18n_json = _context.sent;
          case 12:
            return _context.abrupt("return", yxt_i18n_json);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getLangFileList(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 封装请求,处理返回值，解决try catch嵌套问题
var newResultPromise = function newResultPromise(fun, type) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve, reject) {
      var result;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fun(type);
            case 3:
              result = _context2.sent;
              resolve(["", result]);
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              resolve([_context2.t0, []]);
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
};

// 获取每个模块的json文件
var getModuleJson = function getModuleJson(url) {
  return axios.get(url);
};

// 调用cdn并且处理数据
var formatterJson = function formatterJson(appTypes, modules, result) {
  return new Promise(function (resolve, reject) {
    modules.push("common");
    var cdnLangObj = result && result.data || {};
    if (cdnLangObj && cdnLangObj.appTypes && cdnLangObj.cdnPath) {
      // 获取cdn匹配的模块 https://picobd.yunxuetang.cn/orgsv2/glbl/1675154350830/decorate/zh/custom/i18n_pc.json
      var fileList = [];
      var currntLang = getLanguage();
      appTypes.forEach(function (item) {
        modules.forEach(function (m) {
          cdnLangObj["appTypes"][item] && cdnLangObj["appTypes"][item][m] && cdnLangObj["appTypes"][item][m].forEach(function (i) {
            fileList.push({
              fileUrl: cdnLangObj.cdnPath + "/" + i + "/" + m + "/" + currntLang + "/custom/i18n_" + item + ".json",
              fetchNum: fetchNum
            });
          });
        });
      });
      return resolve(fileList);
    } else {
      return reject();
    }
  });
};
export var getOrgInfoByDomain = function getOrgInfoByDomain(params) {
  return coreApi.get("org/orgname", params);
};
export var getLangList = function getLangList() {
  if (!state.localStorage.getItem("lang4Get")) {
    return [];
  }
  return JSON.parse(state.localStorage.getItem("lang4Get"));
};
export var getLanguage = function getLanguage() {
  var defaultLang = state.localStorage.getItem("yxtLang");
  try {
    if (state.localStorage.getItem("enableI18n") === "1") {
      // 没有默认语种，则当前语种为浏览器的语种
      if (!defaultLang) {
        var browserLang = state.browserLang.toLowerCase();
        if (browserLang === "zh" || browserLang === "zh-CN" || browserLang === "zh-cn" || browserLang === "zh-sg") {
          // 简体中文
          defaultLang = "zh";
        } else if (browserLang.indexOf("es") !== -1 || browserLang.indexOf("en") !== -1) {
          // 英文
          defaultLang = "en";
        } else if (browserLang === "zh-tw" || browserLang === "zh-hk" || browserLang === "zh-mo" || browserLang === "zh-Hant") {
          // 繁体中文
          defaultLang = "ha";
        } else if (browserLang === "vi-vn" || browserLang === "vi") {
          // 越南语
          defaultLang = "vi";
        } else {
          defaultLang = "en";
        }
      }
      var langList = getLangList();
      var hasList = Array.isArray(langList) && langList.length;
      if (hasList && langList.find(function (item) {
        return item.langTag === defaultLang;
      })) {
        // 能匹配到增购的语种
        return defaultLang;
      } else if (hasList && langList.find(function (item) {
        return item.langTag === "en";
      })) {
        // 匹配不到默认语种，但是增购了英文
        return "en";
      } else {
        // 都不能匹配，显示中文
        return "zh";
      }
    } else {
      return "zh";
    }
  } catch (error) {
    // 兜底返回中文
    return "zh";
  }
};
var overrideI18n = function overrideI18n() {
  // 存储.d() 前国际化的key，用于判断是否需要提供默认值（.d()为单步执行方法）
  var preKey = "";
  // eslint-disable-next-line no-extend-native
  String.prototype.d = function (msg) {
    return preKey === this.valueOf() ? msg : this.valueOf();
  };
  // 存储临时的i18n.t对象，用于复写
  var _t = i18n._t;
  // 复写i18n.t 用于支持 国际化默认值（终极兜底方案）。
  i18n._t = function () {
    preKey = arguments[0];
    return _t.apply(i18n, arguments);
  };
};
var isMobile = isMobileClient();
export var i18n = isMobile || !window ? new VueI18n({
  locale: "zh",
  fallbackLocale: "zh"
}) : ((_window = window) == null ? void 0 : _window.i18n_instance) || (window.i18n_instance = new VueI18n({
  locale: "zh",
  fallbackLocale: "zh"
}));
overrideI18n(i18n);
function isSameOrg(info) {
  return window.localStorage.getItem("orgId") === info.orgId || window.localStorage.getItem("domain") === info.domain;
}
function getOrgInfo(_x4) {
  return _getOrgInfo.apply(this, arguments);
} // 加载多语言
function _getOrgInfo() {
  _getOrgInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(info) {
    var res;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(window && window.initOrgKeys && isSameOrg(info))) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return", JSON.parse(window.initOrgKeys));
          case 4:
            _context3.next = 6;
            return getOrgInfoByDomain(info);
          case 6:
            res = _context3.sent;
            window.initOrgKeys = JSON.stringify(res);
            window.localStorage.setItem("SINGLE_CHAT_SWITCH", res.singleChatSwitch);
            return _context3.abrupt("return", res);
          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getOrgInfo.apply(this, arguments);
}
export function loadLanguage(_x5, _x6, _x7) {
  return _loadLanguage.apply(this, arguments);
}
function _loadLanguage() {
  _loadLanguage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(appTypes, modules, orgdomain) {
    var domain, resultAli, result, resultBaidu, formatterList;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (orgdomain) {
              domain = {
                orgId: null,
                domain: orgdomain
              };
            } else {
              domain = {
                orgId: orgId()
              };
              if (!domain.orgId) {
                domain.domain = orgDomain();
              }
            }
            // 缓存写入机构语种信息
            _context4.t0 = domain.orgId || domain.domain;
            if (!_context4.t0) {
              _context4.next = 5;
              break;
            }
            _context4.next = 5;
            return getOrgInfo(domain).then(function (res) {
              state.localStorage.setItem("enableI18n", res.enableI18n);
              state.localStorage.setItem("lang4Get", JSON.stringify(res.lang4Get));
              state.localStorage.setItem("isShowNavFooter", res.isShowNavFooter);
            })["catch"](function () {});
          case 5:
            // 登录后增购了国际化但匹配不到语种，则向后端写入语种
            noMatchSetLang();
            // 加载多语言
            _context4.prev = 6;
            if (!(!state.isBrowser || !!state.feConfig.orgCode)) {
              _context4.next = 9;
              break;
            }
            throw new Error();
          case 9:
            _context4.next = 11;
            return newResultPromise(getLangFileList, "ali");
          case 11:
            resultAli = _context4.sent;
            if (!resultAli[0]) {
              _context4.next = 25;
              break;
            }
            // fecentrLog("获取alicdn资源列表", { w_succ: 0 , error : resultAli[0] });
            // json加载失败，初始化实例，防止执行错误提示，加载过百度cdn后不再初始化该实例
            !isLoadBaidu && (request_axios_instance = null);
            isLoadBaidu = true;
            _context4.next = 17;
            return newResultPromise(getLangFileList, "baidu");
          case 17:
            resultBaidu = _context4.sent;
            if (!resultBaidu[0]) {
              _context4.next = 22;
              break;
            }
            throw new Error();
          case 22:
            result = resultBaidu[1];
            // fecentrLog("获取baiducdn资源列表", { w_succ: 1 });
          case 23:
            _context4.next = 26;
            break;
          case 25:
            result = resultAli[1];
            // fecentrLog("获取alicdn资源列表", { w_succ: 1 });
          case 26:
            _context4.next = 28;
            return formatterJson(appTypes, modules, result);
          case 28:
            formatterList = _context4.sent;
            _context4.next = 31;
            return solveUrl(formatterList);
          case 31:
            return _context4.abrupt("return", _context4.sent);
          case 34:
            _context4.prev = 34;
            _context4.t1 = _context4["catch"](6);
            return _context4.abrupt("return", oldLoadLanguage(appTypes, modules));
          case 37:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[6, 34]]);
  }));
  return _loadLanguage.apply(this, arguments);
}
function noMatchSetLang() {
  return _noMatchSetLang.apply(this, arguments);
}
function _noMatchSetLang() {
  _noMatchSetLang = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var yxtLang, token, isI18n, langList, hasList, result;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            yxtLang = state.localStorage.getItem("yxtLang");
            token = state.localStorage.getItem("token");
            isI18n = state.localStorage.getItem("enableI18n") === "1";
            if (!(isI18n && token && yxtLang)) {
              _context5.next = 12;
              break;
            }
            langList = getLangList();
            hasList = Array.isArray(langList) && langList.length;
            if (!(hasList && langList.findIndex(function (item) {
              return item.langTag === yxtLang;
            }) === -1)) {
              _context5.next = 12;
              break;
            }
            _context5.next = 10;
            return saveLocale(lang);
          case 10:
            result = _context5.sent;
            // 后端没有返回body
            if (result !== "error") {
              localStorage.setItem("yxtLang", lang);
            }
          case 12:
            _context5.next = 16;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](0);
          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 14]]);
  }));
  return _noMatchSetLang.apply(this, arguments);
}
function oldLoadLanguage(_x8, _x9) {
  return _oldLoadLanguage.apply(this, arguments);
}
function _oldLoadLanguage() {
  _oldLoadLanguage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(appTypes, modules) {
    var lang, params, list, _yield$getLangFiles, datas;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            lang = getLanguage();
            modules.push("common");
            params = {
              appTypes: appTypes,
              langTags: [lang],
              moduleTags: modules
            };
            list = null; // 1.ajax请求接口，拿到地址
            _context6.prev = 4;
            _context6.next = 7;
            return getLangFiles(params);
          case 7:
            _yield$getLangFiles = _context6.sent;
            datas = _yield$getLangFiles.datas;
            // fecentrLog("调用search接口获取资源列表", { w_succ: 1 });
            list = datas;
            _context6.next = 15;
            break;
          case 12:
            _context6.prev = 12;
            _context6.t0 = _context6["catch"](4);
            // 兜底
            // fecentrLog("调用search接口获取资源列表", { w_succ: 0, error });
            list = [];
          case 15:
            _context6.next = 17;
            return solveUrl(list);
          case 17:
            return _context6.abrupt("return", _context6.sent);
          case 18:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[4, 12]]);
  }));
  return _oldLoadLanguage.apply(this, arguments);
}
var solveI18n = function solveI18n(lang) {
  if (lang === void 0) {
    lang = {};
  }
  var langKey = getLanguage();
  i18n.mergeLocaleMessage(langKey, lang);
  i18n.locale = langKey;
  i18n.fallbackLocale = langKey;
};
export function solveUrl(_x10) {
  return _solveUrl.apply(this, arguments);
}

/**
 *
 * @param {模块} module
 * @returns
 */
function _solveUrl() {
  _solveUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(datas) {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Promise.all(datas.map( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(item) {
                var res, newUrl, resAgain;
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.prev = 0;
                        res = {};
                        _context7.next = 4;
                        return newResultPromise(getModuleJson, item.fileUrl);
                      case 4:
                        res = _context7.sent;
                        if (!res[0]) {
                          _context7.next = 16;
                          break;
                        }
                        if (item.fileUrl && item.fileUrl.includes(window.feConfig.common.picobd)) {
                          newUrl = item.fileUrl && item.fileUrl.replace(window.feConfig.common.picobd, window.feConfig.common.imagesBaseUrl) || "";
                        } else {
                          newUrl = item.fileUrl && item.fileUrl.replace(window.feConfig.common.imagesBaseUrl, window.feConfig.common.picobd) || "";
                        }
                        _context7.next = 9;
                        return newResultPromise(getModuleJson, newUrl);
                      case 9:
                        resAgain = _context7.sent;
                        if (!resAgain[0]) {
                          _context7.next = 15;
                          break;
                        }
                        // fecentrLog("第二次获取每个模块的json数据", { w_succ: 0 , error: resAgain[0]  });
                        res.data = {};
                        throw new Error();
                      case 15:
                        res = resAgain;
                      case 16:
                        res && res[1] && res[1].data && solveI18n(res[1].data);
                        _context7.next = 22;
                        break;
                      case 19:
                        _context7.prev = 19;
                        _context7.t0 = _context7["catch"](0);
                        console.log(_context7.t0);
                      case 22:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[0, 19]]);
              }));
              return function (_x11) {
                return _ref4.apply(this, arguments);
              };
            }()));
          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _solveUrl.apply(this, arguments);
}
export function setLanguage(_ref3) {
  var _ref3$appTypes = _ref3.appTypes,
    appTypes = _ref3$appTypes === void 0 ? ["pc"] : _ref3$appTypes,
    _ref3$modules = _ref3.modules,
    modules = _ref3$modules === void 0 ? [] : _ref3$modules,
    _ref3$orgdomain = _ref3.orgdomain,
    orgdomain = _ref3$orgdomain === void 0 ? '' : _ref3$orgdomain;
  try {
    return loadLanguage(appTypes, modules, orgdomain);
  } catch (error) {
    // TODO:埋点
    // fecentrLog("设置多语言失败", { error });
  }
}

/**
 *
 * @param {传入的语言} lang
 * @returns
 */
export function changeLanguage(lang) {
  if (lang === void 0) {
    lang = "zh";
  }
  // 切换语言
  var oldLang = state.localStorage.getItem("yxtLang");
  if (lang === oldLang) return;
  state.localStorage.setItem("yxtLang", lang);
  state.localStorage.setItem("isReload", "0");
}
export function langReload() {
  // 语言的刷新
  // 非浏览器环境不刷新
  if (!state.isBrowser) return;
  if (state.localStorage.getItem("isReload") === "0") {
    window.location.reload();
    state.localStorage.setItem("isReload", "1");
  }
}
export var saveLangKey = function saveLangKey(module, params) {
  // 修改key
  return globalApi.post("org/langkey/" + module + "/save", params);
};